@if (this.type() === 'white') {
  <div
    class="w-full h-full rounded flex items-center justify-center text-white hover:text-black transition cursor-pointer gap-2 px-2 scheme-white">
    @if (this.iconName() !== '') {
      <span [innerText]="this.iconName()" class="material-icons"></span>
    }
    @if (this.label() !== '') {
      <span [innerText]="this.label()" class="text-center"></span>
    }
  </div>
}

@if (this.type() === 'transparent') {
  <div
    class="w-full h-full rounded flex items-center justify-center text-white hover:text-black transition cursor-pointer gap-2 px-2 scheme-transparent">
    @if (this.iconName() !== '') {
      <span [innerText]="this.iconName()" class="material-icons"></span>
    }
    @if (this.label() !== '') {
      <span [innerText]="this.label()" class="text-center"></span>
    }
  </div>
}
